export default "__VITE_ASSET__BXo3PxdF__"